import kaannokset_fi from './flexmonster-fi.json'
import kaannokset_en from './flexmonster-en.json'

export default {
    kaannokset_fi, kaannokset_en
  }
  